<template>
  <div class="custom-countdown">
    <img
      v-if="showIcon"
      class="icon-clock"
      src="@/assets/svg/clock-black-light.svg"
      alt="clock"
      width="24"
      height="24"
    >
    <span>{{ formattedTime }}</span>
  </div>
</template>

<script>
export default {
  name: 'CustomCountDown',
  props: {
    initialTime: {
      type: Number,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      remainingTime: 0,
      timer: null
    }
  },
  computed: {
    formattedTime () {
      const minutes = Math.floor(this.remainingTime / 60)
      const seconds = this.remainingTime % 60
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }
  },
  beforeDestroy () {
    this.stopTimer()
  },
  mounted () {
    this.startTimer()
  },
  methods: {
    startTimer () {
      this.remainingTime = this.initialTime
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--
        } else {
          this.stopTimer()
        }
        this.$emit('change', this.remainingTime)
      }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style scoped>
.custom-countdown {
  height: 32px;
  padding: 0 4px;
  min-width: 58px;
  border-radius: 4px;
  width: fit-content;

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;

  background-color: #FEB546;
  font-variant-numeric: tabular-nums;
  .icon-clock {
    margin-right: 8px;
  }
}
</style>
